import { toTestId } from '@panwds/react-utils';
import React from 'react';
import { Badge } from './Badge.js';
export function AlertBadge({ count, dataMetrics, dataTestId }) {
    return (React.createElement(Badge, { dataMetrics: dataMetrics, dataTestId: dataTestId || `badge-alert-${toTestId(count.toString())}`, size: "xs", appearance: "red" }, count));
}
//# sourceMappingURL=AlertBadge.js.map